import React, { useEffect, useState } from "react";
import { Button, Grid, IconButton, Link } from "@material-ui/core";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import ShowDisbursalLoanData from "../../Ornament/ShowDisbursalLoanData";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import EditIcon from "@material-ui/icons/Edit";
import { parseDate } from "utils/Utils";
import SchemeSelection from "../Scheme/SchemeSelection";
import Modal from "components/Modal/Modal";
import { parseAndSetFlag } from "utils/Utils";
import { removeUnderscoresAndCapitalize } from "utils/Utils";
import { referralList } from "assets/properties/properties";
import { loanApplicationStatus } from "assets/properties/properties";
import { formatAmount } from "utils/Utils";
import LoanDetailsDialog from "../LoanDetailsCreditAssessment/LoanDetailsDialog";
import FileUploadDocumentLinkApi from "components/FileUpload/FileUploadDocumetLinkApi"
const LoanDetails = ({
  eligibleLoanAmount,
  actualLoanAmount,
  editable = false,
  setActualLoanAmount,
  actualLoanAmountState,
  setActualLoanAmountState,
  onActualLoanAmount,
  schemeList,
  selectedScheme,
  setSelectedScheme,
  selectedSchemeName,
  schemeChannelList,
  selectedSchemeChannel,
  setSelectedSchemeChannel,
  schemeChannelState,
  setSchemeChannelState,
  referral,
  referalSet,
  referalError,
  setReferalError,
  referralName,
  setreferralName,
  referralNameError,
  referralContact,
  handleChangeContact,
  referralContactError,
  referralAccount,
  setReferralAccount,
  referralAccountError,
  monthlyInterest,
  tenure,
  ltv,
  personalLoanElegiblityAmount,
  crossCell,
  status,
  parseSchemeData,
  showAdjustmentLoanDetailsFields,
  classes,
  SchemeChannelData,
  parentTypeState,
  setParentTypeState,
  onHandleSelected,
  setReferralContactError,
  referralNameList,
  setreferralNameError,
  setreferralAccountError,
  handleSchemeModal,
  totalTareWeight,
  totalCollateralValue,
  prePledgeLoan,
  loanType,
  maxLoanAmountPercentage,
  firstTab,
  panNumber,
  setPanNumber,
  setPanVerified,
  setPanApplicantName,
  panApplicantName,
  setCallInProgress,
  toastUpdate,
  authToken,
  loanApplicationId,
  panVerified,
  mobileNum,
  featureFlag,
  revisedLoanAmount,
  setRevisedLoanAmount,
  revisedRoi,
  setRevisedRoi,
  chargesData,
  notEligibleTopUpAccountType,
  validateThirdPartyAttemptsFlag,
  statuses,
  subStatus,
  enabledMultiLoanAdjsutmentTopUp,
  prepledgeLoanMap,
  disabledSchemeFields = false,
  exposureData,
  actualLoanAmountWithInterest,
  setMeanPurposeOfLoan,
  updatedInterestLtv,
  totalOutstandingAmount,
  enabledLtvSchemeBased,
  enabledApiBasedLtv,
  collateralValue,
  loanData,
  refreshValue,
  form60Lin,
  setForm60Link,
}) => {
  const [dob, setDob] = useState(null);
  const [loanDialogOpen, setLoanDialogOpen] = useState(false);
  const [applicantName, setApplicantName] = useState("");
  const [openSchemeModal, setSchemeOpenModal] = useState(false);
  const selectSchemeModal = parseAndSetFlag(featureFlag?.enableNewSchemeUi);
  const addAdjustmentLoanAccountFlag = parseAndSetFlag(featureFlag?.addAdjustmentLoanAccountFlag);
  const enabledUploadForm60Options = parseAndSetFlag(featureFlag?.enabledUploadForm60Options);
  const enabledCreditAssessmentOnLoanDetails = parseAndSetFlag(featureFlag?.enabledCreditAssessmentOnLoanDetails);
   const [panValidationAttempted, setPanValidationAttempted] = useState({
      success: false,
      error: false,
    });
  const getApplicantDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.panNumber && result?.data?.nameOnPanCard) {
      setPanVerified(true);
      setPanApplicantName(result?.data?.nameOnPanCard);
      setPanNumber(result?.data?.panNumber);
      setPanValidationAttempted({ success: true });
    }
    setMeanPurposeOfLoan(result?.data?.purposeOfLoan)
    setCallInProgress(false);
    setApplicantName(
      result?.data?.nameOnAdhaar || result?.data?.nameOnPanCard
    );
    setDob(parseDate(result?.data?.dob));
    return;
  };
  useEffect(() => {
    if (!firstTab && editable) {
      getApplicantDetails();
    }
  }, [firstTab, editable]);
  const verifyPAN = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url:
        endpoint.SEARCH_PROFILE +
        panNumber?.toUpperCase() +
        "," +
        mobileNum?.trim(),
      authToken: authToken,
    });
    if (result?.data?.length > 1) {
      toastUpdate("Error", "Pan is Linked with other customer", true);
      setPanVerified(false);
      setPanValidationAttempted({ error: true });
      setCallInProgress(false);
    } else {
      if (result?.data?.[0]?.nameOnPanCard && result?.data?.[0]?.panNumber) {

        setPanApplicantName(result?.data?.[0]?.nameOnPanCard);
        setPanNumber(result?.data?.[0]?.panNumber);
        setPanVerified(true);
        setCallInProgress(false);
        setPanValidationAttempted({ success: true });
        return;
      }
      // ADMIN_SEARCH_PANCARD
      const response = await apiHandler({
        url: endpoint.NEW_PAN_CARD_VERIFY,
        authToken: authToken,
        method: "POST",
        data: {
          panNumber: panNumber?.toUpperCase(),
          dob: dob,
          name: applicantName,
        },
      });
      if (response.data.error_code) {
        toastUpdate("Error", response?.data?.user_description, true);
        setPanValidationAttempted({ error: true });
        setCallInProgress(false);
        return;
      } else {
        const updatePanResponse = await apiHandler({
          url: endpoint.ADMIN_UPDATE_PAN,
          method: "POST",
          authToken: authToken,
          data: {
            loanApplicationId: loanApplicationId,
            panNumber: panNumber?.toUpperCase(),
            nameOnPanCard: response.data.name,
            panVerified: true
          },
        });
        setCallInProgress(false);
        if (updatePanResponse.data.error_code) {
          toastUpdate("Error", updatePanResponse?.data?.user_description, true);
          setPanValidationAttempted({ error: true });
          return;
        } else {
          setPanApplicantName(response.data.name);
          setPanVerified(true);
          setPanValidationAttempted({ success: true });
        }
      }
    }
  };
  const hanldeOpenSchemeModal = () => {
    setSchemeOpenModal(!openSchemeModal);
  };
  const [adjustmnet, setAdjument] = useState(false);
  return (
    <Grid container spacing={3}>
      <Grid
        item
        xs={12}
        sm={9}
        md={9}
        style={{ display: "flex", flexWrap: "wrap", padding: "0px" }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField
            label="Total Tare Weight"
            required
            id="total_tare_weight"
            value={Number(Number(totalTareWeight || 0).toFixed(2))}
            disabled
          />
        </Grid>
        {Number(totalCollateralValue) > 0 &&
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField
              label="Total Collateral Value"
              required
              id="total_collateral_value"
              value={Math.round(totalCollateralValue).toLocaleString("en-IN") || "0"}
              disabled
            />
          </Grid>
        }
        {enabledLtvSchemeBased && 
        <Grid item xs={12} md={4} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Existing Total Loan Amount"
          value={formatAmount(totalOutstandingAmount, false)}
          disabled
        />
        {exposureData?.loans?.length > 0 &&
          <Link
            component="button"
            variant="body2"
            onClick={() => setLoanDialogOpen(true)}
            style={{
              marginTop: 6,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            View Loans
          </Link>
        }
      </Grid>}
        {(enabledApiBasedLtv && editable) &&
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField
              label="Total Collateral Value"
              required
              id="total_collateral_value"
              value={Math.round(collateralValue || "0").toLocaleString("en-IN")}
              disabled
            />
          </Grid>
        }
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField
            label="Ornament Value"
            required
            id="ornament_value"
            value={Math.round(eligibleLoanAmount).toLocaleString("en-IN")}
            disabled
          />
        </Grid>
        {editable && <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField
            label="Max Amount Ltv"
            required
            id="ornament_value"
            value={maxLoanAmountPercentage}
            disabled
          />
        </Grid>}
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField
            label="Max Loan Amt(as per ornament)"
            required
            id="maximum_loan_amount"
            value={
              Math.round(
                (eligibleLoanAmount * Number(maxLoanAmountPercentage)) / 100
              ).toLocaleString("en-IN") || ""
            }
            disabled
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField
            label="Monthly interest"
            required
            id="monthly_interest"
            value={Math.round(monthlyInterest).toLocaleString("en-IN")}
            disabled
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField
            label="Tenure (in Months)"
            required
            id="tenure"
            value={tenure}
            disabled
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField label="LTV" required id="ltv" value={ltv} disabled />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomTextField
            label="Actual Loan Amount"
            required
            id="actual_loan_amount"
            error={actualLoanAmountState}
            value={Math.round(actualLoanAmount) || ""}
            setState={setActualLoanAmount}
            type="number"
            setError={setActualLoanAmountState}
            setBlur={onActualLoanAmount}
            blurLabel={eligibleLoanAmount}
            disabled={!editable || notEligibleTopUpAccountType}
          />
        </Grid>
        {(enabledCreditAssessmentOnLoanDetails && selectedScheme?.data?.IS_BULLET) &&
        <>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField label="LTV(including interest)" required id="ltv" value={updatedInterestLtv} disabled />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField label="Actual loan Amount With Interest" required id="ltv" value={actualLoanAmountWithInterest} disabled />
          </Grid>
        </>
        }
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          {editable ? (
            <CustomSelectNew
              label="Scheme Channel*"
              error={schemeChannelState}
              value={selectedSchemeChannel || ""}
              setState={setSelectedSchemeChannel}
              data={SchemeChannelData}
              disabled={!editable || disabledSchemeFields}
              type="channel"
              id="scheme_channel"
              setError={setSchemeChannelState}
            />
          ) : (
            <CustomTextField
              label="Scheme Channel"
              required
              error={schemeChannelState}
              id="scheme_channel"
              value={selectedSchemeChannel}
              disabled
              setError={setSchemeChannelState}
            />
          )}
        </Grid>
        {selectSchemeModal ? (
          editable ? (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                style={{ display: "flex", justifyContent: "center", position: "relative" }}
              >
                {Object?.keys?.(selectedScheme)?.length > 0 ||
                Object?.keys?.(selectedSchemeName).length > 0 ? (
                  <>
                    <CustomeTextField
                      label="Selected Scheme"
                      required
                      value={selectedScheme?.schemeName || ""}
                      type="notCapital"
                      disabled
                      id="selected_scheme"
                    />
        
                    {editable && schemeList?.length > 0 && (
                      <IconButton
                        aria-label="Edit"
                        onClick={() => hanldeOpenSchemeModal()}
                        style={{ position: "absolute", top: -5, right: 0 }}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                  </>
                ) : (
                  schemeList?.length > 0 && (
                    <Button
                      className={classes.button}
                      onClick={() => hanldeOpenSchemeModal()}
                      id="button"
                      style={{ padding: "0px 20%" }}
                      disabled={!selectedSchemeChannel}
                    >
                      Select Scheme
                    </Button>
                  )
                )}
              </Grid>
              
              {revisedLoanAmount !== null && revisedLoanAmount && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                >
                  <CustomTextField
                    label="Revised Amount"
                    id="revisedAmount"
                    value={revisedLoanAmount}
                    disabled
                  />
                </Grid>
              )}
              {revisedRoi !== null && revisedRoi && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                >
                  <CustomTextField
                    label="Revised ROI"
                    id="revisedRoi"
                    value={revisedRoi}
                    disabled
                  />
                </Grid>
              )}
            </>
          ) : (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
              >
                <CustomTextField
                  label="Loan Scheme"
                  required
                  error={parentTypeState}
                  id="loan_Scheme"
                  value={selectedSchemeName}
                  disabled
                  setError={setParentTypeState}
                />
        
                {(Object?.keys?.(selectedScheme)?.length > 0 ||
                  Object?.keys?.(selectedSchemeName).length > 0) && (
                  <a
                    href
                    onClick={() => handleSchemeModal()}
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                      display: "flex",
                      padding: "5px 0px",
                    }}
                  >
                    Loan Scheme
                  </a>
                )}
              </Grid>
              {revisedLoanAmount !== null && revisedLoanAmount && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                >
                  <CustomTextField
                    label="Revised Amount"
                    id="revisedAmount"
                    value={revisedLoanAmount}
                    disabled
                  />
                </Grid>
              )}
              {revisedRoi !== null && revisedRoi && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                >
                  <CustomTextField
                    label="Revised ROI"
                    id="revisedRoi"
                    value={revisedRoi}
                    disabled
                  />
                </Grid>
              )}
            </>
          )
        ) : (
          <>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
            >
              {editable ? (
                <CustomSelectNew
                  label=" Loan Scheme*"
                  error={parentTypeState}
                  value={selectedScheme || ""}
                  setState={onHandleSelected}
                  data={schemeList}
                  disabled={!editable || disabledSchemeFields}
                  type="scheme"
                  id="loan_scheme"
                  setError={setParentTypeState}
                />
              ) : (
                <CustomTextField
                  label=" Loan Scheme"
                  required
                  error={parentTypeState}
                  id="loan_Scheme"
                  value={selectedSchemeName}
                  disabled
                  setError={setParentTypeState}
                />
              )}
        
              {(Object?.keys?.(selectedScheme)?.length > 0 ||
                Object?.keys?.(selectedSchemeName).length > 0) && (
                <a
                  href
                  onClick={() => handleSchemeModal()}
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    display: "flex",
                    padding: "5px 0px",
                  }}
                >
                  Loan Scheme
                </a>
              )}
            </Grid>
          </>
        )}

        {chargesData?.schemeCalculations?.length > 0 &&
          chargesData?.schemeCalculations?.map((item) => (
            <Grid
              item
              key={item?.id}
              xs={12}
              sm={6}
              md={4}
              className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
            >
              <CustomTextField
                label={removeUnderscoresAndCapitalize(
                  item?.chargeType?.toLowerCase()
                )}
                id="personal_loan_elegible_amount"
                value={item?.adjustedAmount}
                disabled
              />
            </Grid>
          ))}
        {(crossCell?.CROSS_SELL === true ||
          (!editable && personalLoanElegiblityAmount)) && (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField
              label="Cross-Sell Amount"
              id="personal_loan_elegible_amount"
              value={personalLoanElegiblityAmount}
              disabled
            />
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
        >
          <CustomSelectNew
            label="Sourcing*"
            id="sourcing"
            error={referalError}
            setError={setReferalError}
            value={referral}
            setState={referalSet}
            data={referralList}
            type="type"
            disabled={!editable}
            // disabled={isOtpMode}
          />
        </Grid>
        {(referral === "Digital_Marketing" ||
          referral === "Existing_Customer") && (
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField
              label="Sourcer Name"
              required
              id="sourcer_name"
              error={referralNameError}
              value={referralName}
              setState={setreferralName}
              type="notCapital"
              setError={setreferralNameError}
              disabled={!editable}
            />
          </Grid>
        )}
        {referral === "Existing_Customer" && (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
            >
              <CustomTextField
                label="Sourcer Contact"
                required
                id="sourcer_content"
                error={referralContactError}
                value={referralContact}
                setState={handleChangeContact}
                setError={setReferralContactError}
                disabled={!editable}
                maxLength="10"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
            >
              <CustomTextField
                label="Sourcer Account Number"
                required
                id="sourcer_lan"
                error={referralAccountError}
                value={referralAccount}
                setState={setReferralAccount}
                type="notCapital"
                setError={setreferralAccountError}
                disabled={!editable}
              />
            </Grid>
          </>
        )}
        {referral === "Internal" && (
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            {statuses ? (
              <CustomSelectNew
                label="Sourcer Name*"
                id="sourcer_name"
                error={referralNameError}
                setError={setreferralNameError}
                value={referralName}
                setState={setreferralName}
                data={referralNameList}
                type="referalName"
                disabled={!editable}
                // disabled={isOtpMode}
              />
            ) : (
              <CustomTextField
                label="Sourcer Name"
                required
                id="sourcer_name"
                value={referralName}
                disabled
              />
            )}
          </Grid>
        )}
        {(!firstTab && status === loanApplicationStatus?.inProcess) && (
          <>
            <Grid
              xs={12}
              sm={6}
              md={4}
              className={classes.fieldContaienr}
              style={{ position: "relative" }}
            >
              <CustomeTextField
                label="PAN No."
                id="pan_number"
                value={panNumber?.toUpperCase()}
                setState={setPanNumber}
                type="notCapital"
                maxLength="10"
                disabled={panVerified || !editable}
                validationState={panValidationAttempted}
                validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
              />
              {editable === true && (
                <Button
                  style={{
                    height: "40px",
                    width: "75px",
                    position: "absolute",
                    right: 0,
                    top: 0,
                    margin: 0,
                  }}
                  size="small"
                  disabled={panVerified}
                  onClick={() => verifyPAN(panNumber, "PAN")}
                  className={classes.nextButton1}
                >
                  verify
                </Button>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Applicant Name"
                required
                id="applicant_name"
                value={panApplicantName}
                // setState={setPanApplicantName}
                disabled={true}
              />
            </Grid>
            {enabledUploadForm60Options &&
              <FileUploadDocumentLinkApi
                authToken={authToken}
                loanApplicationId={loanApplicationId}
                documentLinkField="form60Link"
                supportedMimeType={[
                  "application/pdf",
                  "image/jpeg",
                  "image/png",
                  "image/jpg",
                ]}
                sendFile={(uploadedPath) => setForm60Link(uploadedPath)}
              />
            }
          </>
        )}
        {enabledMultiLoanAdjsutmentTopUp?.includes(subStatus) && (
          <>
            {enabledApiBasedLtv && <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
            >
              <Button
                size="small"
                onClick={() => refreshValue()}
                className={classes.nextButton}
              >
                Refresh
              </Button>
            </Grid>}
                
            {Object.entries(prepledgeLoanMap || {}).map(
              ([accountNumber, amount], index) => {
                const selectedLoan = loanData?.find(
                  loan => loan?.loanAccountNumber === accountNumber
                );
              
                const adjustedLoanInterest =
                  (Number(selectedLoan?.accuralInterest) || 0) +
                  (Number(selectedLoan?.outstandingInterest) || 0);
              
                return (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className={classes.inputContainer}
                    key={accountNumber}
                  >
                    <Grid container className={classes.inputFieldContainer}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                      >
                        <CustomTextField
                          label="Adjusted Loan Account Number"
                          required
                          id={`adjusted_loan_acc_number_${index}`}
                          value={accountNumber}
                          disabled
                        />
                      </Grid>
                
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                      >
                        <CustomTextField
                          label="Adjusted Loan Amount"
                          id={`loan_amount_${index}`}
                          value={amount}
                          disabled
                        />
                      </Grid>
                
                      {enabledApiBasedLtv && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={4}
                          className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                        >
                          <CustomTextField
                            label="Pending Interest"
                            id={`pending_interest_${index}`}
                            value={adjustedLoanInterest}
                            disabled
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                );
              }
            )}
          </>
        )}
        {(showAdjustmentLoanDetailsFields && !enabledMultiLoanAdjsutmentTopUp?.includes(subStatus))&& (
          <Grid xs={12} sm={12} md={12} lg={12}>
            {loanType === "RE_PLEDGE" || subStatus === "POST_PLEDGE"? (
              <ShowDisbursalLoanData
                classes={classes}
                editable={false}
                prePledgeLoan={prePledgeLoan}
                repledgeCase
                setMainActualLoanAmount={setActualLoanAmount}
                notEligibleTopUpAccountType={notEligibleTopUpAccountType}
                prepledgeLoanAmount={actualLoanAmount}
                featureFlag={featureFlag}
                enabledApiBasedLtv={enabledApiBasedLtv}
              />
            ) : (
              <>
                {(status === "INPROCESS" && addAdjustmentLoanAccountFlag) && <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "black",
                      gap: "20px",
                      fontSize: "16x",
                    }}
                  >
                    <input
                      style={{ marginTop: 2, width: "30px", height: "30px" }}
                      type="checkbox"
                      value={adjustmnet}
                      name="Profiling"
                      onChange={(e) => setAdjument(!adjustmnet)}
                      disabled={!editable}
                      checked={adjustmnet}
                    />
                    Do you want to adjustment the loan
                  </label>
                </Grid>
              }
                <Grid item xs={12} sm={12} md={12}>
                  {adjustmnet && (
                    <ShowDisbursalLoanData classes={classes} editable={true} featureFlag={featureFlag} enabledApiBasedLtv={enabledApiBasedLtv}/>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        )}
      </Grid>
      <Grid xs={12} sm={3} md={3} lg={3} style={{ marginTop: "15px" }}>
        {selectedScheme?.loanSchemeChannel && (
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ margin: "0% 2% 0px 2%" }}
          >
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "start" }}
            >
              <span>
                <span>Effective ROI*</span>
                <span
                  style={{
                    fontSize: "x-small",
                    marginLeft: 20,
                  }}
                >
                  Effective (ROI) if due Interest is fully paid online within
                  every
                </span>
              </span>
              <Grid xs={12} sm={12} md={12} lg={12} style={{ display: "flex" }}>
                <Grid
                  xs={12}
                  sm={4}
                  md={6}
                  lg={6}
                  style={{ textAlign: "left" }}
                >
                  <Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p style={{ marginBottom: 0 }}>
                        <b>Days</b>
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>0-30</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>31-60</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>61-90</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>91-120</label>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  xs={12}
                  sm={8}
                  md={6}
                  lg={6}
                  style={{ textAlign: "left" }}
                >
                  <Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p style={{ marginBottom: 0 }}>
                        <b>Interest Rate</b>
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>
                        {parseSchemeData?.monthlyInterestRate30Days +
                          "% PM (" +
                          parseSchemeData?.yearlyInterestRate30Days +
                          "% PA)"}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>
                        {parseSchemeData?.monthlyInterestRate60Days +
                          "% PM (" +
                          parseSchemeData?.yearlyInterestRate60Days +
                          "% PA)"}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>
                        {parseSchemeData?.monthlyInterestRate90Days +
                          "% PM (" +
                          parseSchemeData?.yearlyInterestRate90Days +
                          "% PA)"}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <label>
                        {parseSchemeData?.monthlyInterestRateMax +
                          "% PM (" +
                          parseSchemeData?.yearlyInterestRateMax +
                          "% PA)"}
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
      {openSchemeModal && (
        <Modal
          open={openSchemeModal}
          title="Select Loan Scheme"
          onClose={() => hanldeOpenSchemeModal(false)}
        >
          <SchemeSelection
            schemeList={schemeList}
            eligibleAmount={Math.round(
              (eligibleLoanAmount * Number(maxLoanAmountPercentage)) / 100
            ).toLocaleString("en-IN")}
            handleSchemeModal={handleSchemeModal}
            onHandleSelected={onHandleSelected}
            selectedScheme={selectedScheme}
            hanldeOpenSchemeModal={hanldeOpenSchemeModal}
            eligibleLoanAmount={eligibleLoanAmount}
            revisedLoanAmount={revisedLoanAmount}
            setRevisedLoanAmount={setRevisedLoanAmount}
            revisedRoi={revisedRoi}
            setRevisedRoi={setRevisedRoi}
          />
        </Modal>
      )}
      {loanDialogOpen &&
        <LoanDetailsDialog
          open={loanDialogOpen}
          onClose={() => setLoanDialogOpen(false)}
          loans={exposureData?.loans || []}
        />
      }
    </Grid>
  );
};

export default LoanDetails;
